export const accountSlideoutButtonIds = {
    switchToThisUser: 'switch-to-this-user',
    sendNotification: 'send-notification',
    copyPassword: 'copy-password',
    delete: 'delete',
    resetAuthenticationFactors: 'reset-authentication-factors',
    resetEmailPassword: 'reset-email-password',
    unlockAccount: 'reset-email-password',
    changeLoginEmail: 'change-login-email',
};
export const oktaStatusType = {
    LOCKED_OUT: 'LOCKED_OUT',
    PASSWORD_EXPIRED: 'PASSWORD_EXPIRED',
    PASSWORD_RESET: 'PASSWORD_RESET',
    PENDING_USER_ACTION: 'PROVISIONED',
    RECOVERY: 'RECOVERY',
};
